import styled from 'styled-components';
// eslint-disable-next-line import/no-unresolved
import { breakpoint } from '@themes';

export const AlbumsCarouselSliceWrapper = styled.div`
  width: auto;
  padding-top: 24px;
  padding-bottom: 24px;

  ${breakpoint('lg')`
    padding-top: 40px;
    padding-bottom: 40px;
  `}
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-left: 16px;
  margin-right: 16px;

  ${breakpoint('sm')`
    margin-left: 32px;
    margin-right: 32px;
  `}

  ${breakpoint('lg')`
    margin-left: 80px;
    margin-right: 80px;
  `}
`;

export const Title = styled.h4`
  color: ${(props) => props.theme.colors.lightishGrey};
  font-size: 18px;
  line-height: 25px;
  font-family: 'Inter SemiBold';
  margin-bottom: 16px;

  ${breakpoint('lg')`
    font-size: 24px;
    line-height: 33px;
    margin-bottom: 24px;
  `}
`;

export const ViewAllLink = styled.a`
  font-size: 14px;
  line-height: 18px;
  color: ${(props) => props.theme.colors.white};
  text-decoration: underline;

  ${breakpoint('lg')`
    font-size: 18px;
    line-height: 24px;
  `}
`;

export const CarouselWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  & .swiper--wrapper {
    height: 100%;
    padding-left: 16px;
    padding-right: 0;

    ${breakpoint('sm')`
      padding-left: 32px;
      padding-right: 0;
    `}

    ${breakpoint('lg')`
      padding-left: 80px;
      padding-right: 0;
    `}
  }

  & .swiper {
    height: 100%;
    padding-left: 0px;
    padding-right: ${(props) => (props.noRightPadding ? 0 : '16px')};

    ${breakpoint('sm')`
      padding-right: ${(props) => (props.noRightPadding ? 0 : '32px')};
    `}

    ${breakpoint('lg')`
      padding-right: ${(props) => (props.noRightPadding ? 0 : '80px')};
    `}
  }

  & .home--carousel--wrapper {
    & .swiper--wrapper {
      height: 100%;
      padding-left: 16px;
      padding-right: 16px;

      ${breakpoint('sm')`
        padding-left: 32px;
        padding-right: 32px;
      `}

      ${breakpoint('lg')`
        padding-left: 80px;
        padding-right: 80px;
      `}
    }
  }
`;
